export const PICTURE_SYSTEM_IDENTIFIERS = {
  IMAGE: 'image',
  LIBRARY: 'library',
  FILE: 'file',
} as const;
